import { HelpCenterRepositoryInterface } from "@/data/persistences/repositories/contracts/HelpCenterRepositoryInterface";
import { HelpCenterVisitorToken } from "@/domain/entities/HelpCenterVisitorToken";
import ApiService from "@/app/infrastructures/services/ApiService";
import { HelpCenterMapper } from "@/data/persistences/mappers/HelpCenterMapper";
import { HelpCenterEndpoints } from "@/app/infrastructures/endpoints/horde/HelpCenterEndpoints";

export class HelpCenterApiRepository implements HelpCenterRepositoryInterface {
  private service: ApiService;
  private mapper: HelpCenterMapper;
  private endpoints: HelpCenterEndpoints;

  constructor(
    service: ApiService,
    mapper: HelpCenterMapper,
    endpoints: HelpCenterEndpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getVisitorToken(): Promise<HelpCenterVisitorToken> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.helpCenterVisitorToken(),
      {}
    );
    return this.mapper.convertVisitorTokenFromApi(resp);
  }
}
